import React from 'react';
import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter as Router, Routes, Route, Outlet } from 'react-router-dom';
import Navigation from './components/Navigation';
import ScrollToTop from './components/ScrollToTop';
import Footer from './components/Footer';
import CookieConsent from './components/CookieConsent';
import HomePage from './pages/HomePage';
import EvenementPage from './pages/EvenementPage';
import InscriptionsPage from './pages/InscriptionsPage';
import MentionsLegalesPage from './pages/MentionsLegalesPage';
import Edition3Page from './pages/Edition3Page';
import Edition2Page from './pages/Edition2Page';
import ThankYouPage from './pages/ThankYouPage';
import ThankYouEdition2Page from './pages/ThankYouEdition2Page';
import ContactPage from './pages/ContactPage';
import BlogPage from './pages/BlogPage';
import RessourcesPage from './pages/RessourcesPage';
import ImageLicensePage from './pages/ImageLicensePage';
import NotFoundPage from './pages/NotFoundPage';

import { AuthProvider } from './members/context/AuthContext';
import ProtectedRoute from './members/components/ProtectedRoute';
import MemberLayout from './members/components/MemberLayout';
import LoginPage from './members/pages/LoginPage';
import CheckEmailPage from './members/pages/CheckEmailPage';
import VerifyPage from './members/pages/VerifyPage';
import DashboardPage from './members/pages/DashboardPage';
import EditionsPage from './members/pages/EditionsPage';
import EditionDetailPage from './members/pages/EditionDetailPage';
import DirectoryPage from './members/pages/DirectoryPage';

const PublicLayout: React.FC = () => (
  <>
    <Navigation />
    <Outlet />
    <Footer />
  </>
);

function App() {
  return (
    <HelmetProvider>
    <Router>
      <ScrollToTop />
      <div className="App">
        <Routes>
          {/* Public site */}
          <Route element={<PublicLayout />}>
            <Route path="/" element={<HomePage />} />
            <Route path="/evenement" element={<EvenementPage />} />
            <Route path="/inscriptions" element={<InscriptionsPage />} />
            <Route path="/mentions-legales" element={<MentionsLegalesPage />} />
            <Route path="/edition-3" element={<Edition3Page />} />
            <Route path="/edition-2" element={<Edition2Page />} />
            <Route path="/thank-you" element={<ThankYouPage />} />
            <Route path="/thank-you-edition-2" element={<ThankYouEdition2Page />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/blog" element={<BlogPage />} />
            <Route path="/ressources" element={<RessourcesPage />} />
            <Route path="/image-license-info" element={<ImageLicensePage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Route>

          {/* Members — public auth pages */}
          <Route path="/members" element={<LoginPage />} />
          <Route path="/members/check-email" element={<CheckEmailPage />} />
          <Route path="/members/verify" element={<VerifyPage />} />

          {/* Members — protected pages */}
          <Route
            element={
              <AuthProvider>
                <ProtectedRoute>
                  <MemberLayout />
                </ProtectedRoute>
              </AuthProvider>
            }
          >
            <Route path="/members/dashboard" element={<DashboardPage />} />
            <Route path="/members/editions" element={<EditionsPage />} />
            <Route path="/members/editions/:id" element={<EditionDetailPage />} />
            <Route path="/members/directory" element={<DirectoryPage />} />
          </Route>
        </Routes>
        <CookieConsent />
      </div>
    </Router>
    </HelmetProvider>
  );
}

export default App;
